<template>
  <transition name="fade">
    <div v-if="isOpen" class="fixed gd-modal flex justify-center items-center inset-0" :class="name">
      <div
        @click="!persist && close()"
        class="fixed inset-0 w-full h-full"
        :class="{
          'opacity-50 bg-white': bgType == 'white',
          'opacity-75 bg-dark': bgType == 'dark',
          'opacity-25 bg-dark': bgType == 'regular',
          'opacity-75 bg-black': bgType == 'black'
        }"
      ></div>
      <div class="max-h-full w-full h-full p-8 flex items-center justify-center flex-col">
        <div
          class="bg-white rounded-lg shadow-2xl relative flex flex-col custom-scrollbars overflow-y-auto"
          :class="{ 'overflow-hidden': !noOverflow }"
          :style="{height, maxWidth, width}"
        >
          <div
            v-if="title"
            class="border-solid border-b border-grey-200 h-16 w-full flex flex-row items-center justify-between px-8 text-grey-700 capitalize"
          >
            <span class="text-lg font-bold" v-html="title"></span>
            <span @click="close()" v-if="!hideClose"><close-icon class="h-5 w-5 cursor-pointer"></close-icon> </span>
          </div>
          <slot></slot>
        </div>
        <div
          class="relative mt-1" 
          :style="{maxWidth, width}"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import CloseIcon from '../assets/close-icon-new.svg';

export default {
  name: 'GdModal',
  components: { CloseIcon },
  props: {
    name: { required: true },
    width: { default: '600px' },
    maxWidth: { default: '' },
    height: { default: '' },
    title: { default: '' },
    bgType: { default: 'white' },
    noOverflow: { default: false },
    persist: {
      type: Boolean,
      default: true
    },
    hideClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { isOpen: false };
  },
  mounted() {
    this.$root.$on('modal-open', name => {
      if (name === this.name) this.open();
    });
    this.$root.$on('modal-close', name => {
      if (name === this.name) this.close();
    });
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('opened');
    },
    close() {
      this.isOpen = false;
      this.$emit('closed');
    },
    onCloseByEscapeKey (e) {
      if (e.key === 'Escape') this.close();
    },
  },
  watch:{
    isOpen(val){
      if (this.persist) return;
      if(val)
        return window.addEventListener('keydown', this.onCloseByEscapeKey);
      return window.removeEventListener('keydown', this.onCloseByEscapeKey);
    }
    
  
  }
};
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.gd-modal {
  z-index: 60;

  &.upgrade {
    z-index: 100;
  }
}
</style>